import React from 'react';
import Icon from '../../../components/AppIcon';

const SupportSection = () => {
  const supportOptions = [
    {
      icon: 'BookOpen',
      title: 'Documentation',
      description: 'Comprehensive guides and tutorials for both cloud and desktop solutions',
      link: '/support-faq'
    },
    {
      icon: 'Video',
      title: 'Video Tutorials',
      description: 'Step-by-step video guides for setup, configuration, and daily operations',
      link: '/support-faq'
    },
    {
      icon: 'MessageCircle',
      title: 'Live Chat',
      description: 'Real-time assistance from our support team during business hours',
      link: 'https://app.cultaz.com'
    },
    {
      icon: 'Users',
      title: 'Community Forum',
      description: 'Connect with other Cultaz users and share best practices',
      link: '/support-faq'
    }
  ];

  const implementationSteps = [
    {
      step: '1',
      title: 'Initial Consultation',
      description: 'We discuss your business needs and recommend the best solution',
      duration: '30-60 minutes'
    },
    {
      step: '2',
      title: 'System Setup',
      description: 'Our team configures your Cultaz system based on your requirements',
      duration: '1-2 days'
    },
    {
      step: '3',
      title: 'Data Migration',
      description: 'We help transfer your existing inventory and customer data',
      duration: '2-3 days'
    },
    {
      step: '4',
      title: 'Staff Training',
      description: 'Comprehensive training for your team on system usage',
      duration: '1 day'
    },
    {
      step: '5',
      title: 'Go Live',
      description: 'Launch your system with ongoing support and monitoring',
      duration: '1 day'
    }
  ];

  return (
    <div className="space-y-12 md:space-y-16 lg:space-y-20">
      <div>
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Additional Support Resources
          </h2>
          <p className="font-body text-base md:text-lg text-muted-foreground max-w-3xl mx-auto">
            Access comprehensive support materials and connect with our team through multiple channels
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {supportOptions?.map((option, index) => (
            <a
              key={index}
              href={option?.link}
              className="bg-card rounded-xl shadow-purple border border-border p-6 transition-smooth hover:shadow-purple-lg hover:-translate-y-1 group"
            >
              <div className="flex h-14 w-14 items-center justify-center rounded-lg bg-primary/10 mb-4 group-hover:bg-primary/20 transition-smooth">
                <Icon name={option?.icon} size={28} color="var(--color-primary)" strokeWidth={2} />
              </div>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground mb-2">
                {option?.title}
              </h3>
              <p className="font-body text-sm md:text-base text-muted-foreground">
                {option?.description}
              </p>
            </a>
          ))}
        </div>
      </div>
      <div className="bg-card rounded-2xl shadow-purple-lg border border-border p-6 md:p-8 lg:p-10">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Implementation Timeline
          </h2>
          <p className="font-body text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Our structured onboarding process ensures smooth transition to Cultaz
          </p>
        </div>

        <div className="space-y-6 md:space-y-8">
          {implementationSteps?.map((item, index) => (
            <div key={index} className="flex items-start space-x-4 md:space-x-6">
              <div className="flex-shrink-0 flex h-12 w-12 md:h-14 md:w-14 items-center justify-center rounded-full bg-primary text-primary-foreground font-heading text-lg md:text-xl font-bold">
                {item?.step}
              </div>
              <div className="flex-1 min-w-0 pt-1">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-2">
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground mb-1 sm:mb-0">
                    {item?.title}
                  </h3>
                  <span className="inline-flex items-center px-3 py-1 rounded-full bg-primary/10 font-body text-sm text-primary font-medium whitespace-nowrap w-fit">
                    {item?.duration}
                  </span>
                </div>
                <p className="font-body text-sm md:text-base text-muted-foreground">
                  {item?.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-10 p-6 bg-gradient-to-br from-primary/10 to-secondary/10 rounded-xl border border-primary/20">
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/20">
              <Icon name="Clock" size={24} color="var(--color-primary)" strokeWidth={2} />
            </div>
            <div>
              <h4 className="font-heading text-lg md:text-xl font-bold text-foreground mb-2">
                Total Implementation Time
              </h4>
              <p className="font-body text-sm md:text-base text-muted-foreground">
                Complete setup and training typically takes 5-7 business days. We work around your schedule to minimize disruption to your operations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportSection;